import { inject, observer } from 'mobx-react';
import React from 'react';

import { AprobacionesTableColumns, RegistroEnviardo } from '../../models';
import { AprobacionStore } from '../../stores';

import { Col, Select, Table, Row } from 'antd';
import { ConsultaStore } from '../../stores/consultaStore';
import { EstadosRegistro } from '../../models/Consultas';

interface TablaRevisionesProps {
    aprobacionStore?: AprobacionStore;
    dataSourceTabla?: RegistroEnviardo[];
    consultaStore?: ConsultaStore;
}

@inject('aprobacionStore')
@inject('consultaStore')
@observer
export class TablaRevisiones extends React.Component<TablaRevisionesProps> {
    state = {
        searchText: ''
    };

    async componentDidMount() {
        const { aprobacionStore, consultaStore } = this.props;
        aprobacionStore!.filtros!.Estado = 2;
        aprobacionStore!.filtros!.Municipio = 0;
        await consultaStore!.getMunicipios();
        await aprobacionStore!.getEnviarForms();
    }

    handleFila = async (record: RegistroEnviardo) => {
        const { aprobacionStore } = this.props;
        aprobacionStore!.selectForm(record);
        await aprobacionStore!.getFormById();
    };

    onRow = (record: RegistroEnviardo, index: number) => ({
        onClick: () => this.handleFila(record)
    });

    renderEstatus = () => {
        return (
            <Select style={{ width: '100%' }} placeholder="Capturado" onChange={this.handleEstatus}>
                <Select.Option key={2}>Capturado</Select.Option>
                <Select.Option key={6}>Corregido</Select.Option>
                <Select.Option key={3}>Aprobado</Select.Option>
            </Select>
        );
    };
    handleEstatus = (value: any) => {
        const { aprobacionStore } = this.props;
        aprobacionStore!.filtros!.Estado = value;
        aprobacionStore!.getEnviarForms();
    };

    renderMunicipio = () => {
        return (
            <Select
                showSearch={true}
                style={{ width: '100%' }}
                placeholder="Todos"
                optionFilterProp="children"
                onChange={this.handleMunicipio}
            >
                <Select.Option key={'0'}>Todos</Select.Option>
                {this.props.consultaStore!.listaMunicipios.map(municipio => (
                    <Select.Option key={municipio.id}>{municipio.nombre}</Select.Option>
                ))}
            </Select>
        );
    };
    handleMunicipio = (value: any) => {
        const { aprobacionStore } = this.props;
        aprobacionStore!.filtros!.Municipio = value;
        aprobacionStore!.getEnviarForms();
    };

    render() {
        const { aprobacionStore } = this.props;
        return (
            <>
                <Row>
                    <Col span={4} style={{ textAlign: 'center' }}>
                        <strong>Municipio</strong>
                        {this.renderMunicipio()}
                    </Col>
                    <Col span={4} style={{ textAlign: 'center' }}>
                        <strong>Estatus</strong>
                        {this.renderEstatus()}
                    </Col>
                </Row>
                <Row style={{ paddingTop: '20px' }}>
                    <Table
                        columns={AprobacionesTableColumns}
                        dataSource={aprobacionStore!.forms}
                        onRow={this.onRow}
                        rowKey="id"
                        bordered={true}
                        loading={aprobacionStore!.cargando}
                    />
                </Row>
            </>
        );
    }
}
